<kt-base-modal [title]="tab === 'site-folder' ? 'Site Folder View' : 'Resources View'">
    <div modal-body class="p-0">
        <kt-location-resources [locationId]="locationId" [tab]="tab" [readOnly]="true"></kt-location-resources>
    </div>
</kt-base-modal>
